//
// Copyright (c) 2026 Comcast
//

import { combineReducers } from 'redux'
import { api } from 'api/api'
import ticket from './ticket'
import notification from './notification'
import notificationModal from './notificationModal'
import session from './session'
import sessionUser from './sessionUser'
import modalForm from './modalForm'
import feedback from './feedback'

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  feedback,
  modalForm,
  notification,
  notificationModal,
  session,
  sessionUser,
  ticket,
})

export default rootReducer
